import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectedPanelEnum } from '@app/core';
import { InsurancesQueryParamsInterface } from '@app/my-zone/interfaces/insurances-query-params.interface';
import { PremiumImpactService } from '@app/my-zone/shared/premium-impact-modal';
import { DateService, ErrorInterface, InsurancePolicyActionService, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-policy-holder-form',
    templateUrl: './insurance-policy-holder-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsurancePolicyHolderFormComponent implements OnInit{

    @Input() public purchasedProduct!: PurchasedProductInterface;

    public isDisabled: boolean;
    public form: UntypedFormGroup;
    public errors: ErrorInterface[];

    public get endDate(): AbstractControl {
        return this.form.get('endDate');
    }

    public get minimumDate(): string {
        return this.dateService.add(1, 'day');
    }

    constructor(
        private dateService: DateService,
        private insurancePolicyActionService: InsurancePolicyActionService,
        private router: Router,
        private changeDetectorRef: ChangeDetectorRef,
        private premiumImpactService: PremiumImpactService,
    ) {
        this.isDisabled = false;
        this.errors = [];
    }

    public ngOnInit(): void {
        this.form = this.createForm();
    }

    public onSubmit(): void {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }

        this.insurancePolicyActionService
            .endRegularDriver$({
                endDate: this.endDate.value,
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            })
            .subscribe({
                next: () => this.onEndRegularDriverSuccess(),
                error: (errors) => this.onEndRegularDriverError(errors),
            });

        this.isDisabled = true;
        this.errors = [];
    }

    private onEndRegularDriverSuccess(): void {
        this.isDisabled = false;
        this.errors = [];
        this.closePanel();
        this.onGetChanges(this.endDate.value, this.purchasedProduct.productSequenceNumber);
        this.changeDetectorRef.detectChanges();
    }

    private closePanel(): void {
        const queryParams: InsurancesQueryParamsInterface = {
            panel: SelectedPanelEnum.Close,
            productId: this.purchasedProduct.productId,
            productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            scroll: true,
        };

        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
        });
    }

    private onGetChanges(referenceDate: string, sequenceNumber: number): void {
        this.premiumImpactService
            .getChanges(referenceDate, sequenceNumber)
            .subscribe();
    }

    private onEndRegularDriverError(errors: ErrorInterface[]): void {
        this.errors = errors;
        this.isDisabled = false;
        this.changeDetectorRef.detectChanges();
    }

    private createForm(): FormGroup {
        return new UntypedFormGroup({
            endDate: new FormControl('', [Validators.required]),
        });
    }


}
